import * as React from 'react'
import { Link } from 'react-router-dom'

interface IProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string
  isInternal?: boolean
}

// This component given a path will either return a link that will do a
// full page refresh, or a SPA history pushState update
const CategoryLink = ({ isInternal, ...props }: IProps) => {
  const { to } = props

  if (isInternal) {
    return <Link {...props} />
  } else {
    return (
      <a {...props} href={to}>
        {props.children}
      </a>
    )
  }
}

export default CategoryLink
